import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'

import { Layout, Row, Col, Space, Card, Typography } from 'antd'
import { StyledTypographyText } from '../../styled-components/Typography'
import { menuPortal, device, logoHeaderBase64, MenuPortalObj, PortalKey } from '../../constant/constant'
import { useHistory } from 'react-router-dom'
import { routesObj } from '../../routers/router'
import usePortal from '../../hooks/usePortal'
import useStore from '../../stores/useStore'

const { Header } = Layout
const { Text } = Typography

const Container = styled.div`
    height: 100vh;
    position: relative;
    background-color: #f6f6f6;

    @media ${device.tablet} {
        height: 160vh;
    }

    @media ${device.mobileL} {
        height: 160vh;
    }

    @media ${device.mobileM} {
        height: 160vh;
    }

    @media ${device.mobileS} {
        height: 180vh;
    }
`
const VerticalCenter = styled.div`
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: #f6f6f6;
    @media ${device.tablet} {
        top: 10%;
        transform: translate(-50%, -10%);
    }

    @media ${device.mobileL} {
        top: 10%;
        transform: translate(-50%, -10%);
    }

    @media ${device.mobileM} {
        top: 10%;
        transform: translate(-50%, -10%);
    }

    @media ${device.mobileS} {
        top: 10%;
        transform: translate(-50%, -10%);
    }
`

const TypographyTitle = styled<any>(Text)`
    color: ${(props) => props.color};

    font-weight: 600;

    @media ${device.desktopL} {
        font-size: 1.08rem;
    }

    @media ${device.desktop} {
        font-size: 1.08rem;
    }

    @media ${device.laptop} {
        font-size: 1.08rem;
    }

    @media ${device.laptopL} {
        font-size: 1.08rem;
    }

    @media ${device.tablet} {
        font-size: 1.08rem;
    }

    @media ${device.mobileL} {
        font-size: 1rem;
    }

    @media ${device.mobileM} {
        font-size: 1rem;
    }

    @media ${device.mobileS} {
        font-size: 1rem;
    }
`
const StyleHeaderPortal = styled(Header)({
    backgroundColor: 'transparent',
    textAlign: 'center',
    paddingTop: '50px',
    marginBottom: '70px',
})

const StyleLogo = styled.img`
    width: 216px;
    height: 61px;

    @media ${device.desktopL} {
        width: 216px;
        height: 61px;
    }

    @media ${device.desktop} {
        width: 216px;
        height: 61px;
    }

    @media ${device.laptop} {
        width: 216px;
        height: 61px;
    }

    @media ${device.laptopL} {
        width: 216px;
        height: 61px;
    }

    @media ${device.tablet} {
        width: 160px;
        height: 44px;
    }

    @media ${device.mobileL} {
        width: 160px;
        height: 44px;
    }

    @media ${device.mobileM} {
        width: 160px;
        height: 44px;
    }

    @media ${device.mobileS} {
        width: 160px;
        height: 44px;
    }
`
const StyledCardPortal = styled(Card)({
    '& .ant-card-actions > li': {
        float: 'left',
        margin: '0px 0',
        color: 'rgba(0, 0, 0, 0.45)',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    boxShadow: '0px 20px 20px #0000000F',
})

const StyledHeader = styled(Text)`
    color: #166936;
    font-weight: 700;

    @media ${device.desktopL} {
        font-size: 2rem;
    }

    @media ${device.desktop} {
        font-size: 2rem;
    }

    @media ${device.laptop} {
        font-size: 2rem;
    }

    @media ${device.laptopL} {
        font-size: 1.8rem;
    }

    @media ${device.tablet} {
        font-size: 1.6rem;
    }

    @media ${device.mobileL} {
        font-size: 1.3rem;
    }

    @media ${device.mobileM} {
        font-size: 1.3rem;
    }

    @media ${device.mobileS} {
        font-size: 1.3rem;
    }
`
const StyledSubHeader = styled(StyledTypographyText)({ color: '#818181', fontSize: 18 })
const StyledTitleMenu = styled(StyledTypographyText)({ color: '#FFFFFF', fontSize: 18 })

const StyledButtonMenu = styled.div`
    background-color: ${(props: any) => props.color};
    height: 60px;
    vertical-align: middle;
    line-height: 60px;
    &:hover {
        background-color: ${(props: any) => props.color};
        opacity: 80%;
    }
`

const StyledLogoMenu = styled.img({
    width: '70%',
    margin: 20,
})

interface PortalProps {}
const Portal: FC<PortalProps> = () => {
    const history = useHistory()
    const { userStore } = useStore()
    const [profile, setProfile] = useState<Boolean>(Object.keys(userStore.profileInfo).length !== 0)

    const { goToWebBase } = usePortal()
    const handleClick = (portal: MenuPortalObj) => (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        switch (portal.uid) {
            case PortalKey.SELF:
                history.replace(routesObj.user.path)
                break
            case PortalKey.WB:
                // window.location.href = 'https://gdev.geotalent.co.th/gt-cbt-webbase/sign-in'
                goToWebBase()
                break
            default:
                break
        }
    }
    useEffect(() => {
        if (!profile) {
            const start = async () => {
                await userStore.getUserProfile()
                setProfile(true)
            }

            start()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <>
            <Container>
                <VerticalCenter style={{ width: '700px' }}>
                    <StyleHeaderPortal>
                        <StyleLogo src={logoHeaderBase64} />
                    </StyleHeaderPortal>
                    <Row justify='center'>
                        <Col>
                            <Space direction='vertical' align='center' size={1}>
                                <StyledHeader>{`ยินดีต้อนรับ ${userStore.profileInfo.firstName ?? ''} ${
                                    userStore.profileInfo.lastName ?? ''
                                } `}</StyledHeader>
                                <StyledSubHeader>กรุณาเลือกระบบที่คุณต้องการเข้าใช้งาน</StyledSubHeader>
                            </Space>
                        </Col>
                    </Row>
                    <Row
                        gutter={[18, 8]}
                        justify='space-between'
                        style={{
                            marginTop: 40,
                            backgroundColor: '#F6F6F6',
                        }}
                    >
                        {menuPortal.map((portal) => {
                            return (
                                <Col key={portal.uid} xs={24} md={24} lg={12}>
                                    <StyledCardPortal
                                        bodyStyle={{
                                            // height: 319,
                                            // minWidth: 464,
                                            width: '100%',
                                            textAlign: 'center',
                                            // marginLeft: '22%',
                                        }}
                                        actions={[
                                            <StyledButtonMenu color={portal.color} onClick={handleClick(portal)}>
                                                <StyledTitleMenu>
                                                    {portal.labelButton} {'>'}
                                                </StyledTitleMenu>
                                            </StyledButtonMenu>,
                                        ]}
                                    >
                                        <Space direction='vertical' align='center'>
                                            <StyledLogoMenu src={portal.logo} alt='Self Assessment System' />
                                            <TypographyTitle color={portal.color}>{portal.label}</TypographyTitle>
                                            <div
                                            // css={{
                                            //     color: '#818181',
                                            //     fontSize: '14px !important',
                                            // }}
                                            >
                                                {portal.description}
                                            </div>
                                        </Space>
                                    </StyledCardPortal>
                                </Col>
                            )
                        })}
                    </Row>
                </VerticalCenter>
            </Container>
        </>
    )
}
// Portal = observer(Portal)
// Portal = withDialog(Portal)
export default Portal
